import { connect } from 'react-redux';
import SingleProduct from './SingleProduct';
import { setViewedProduct } from '../../../../../../../store/products/actions';
import { getViewedProduct } from '../../../../../../../store/products/selectors';

const mapStateToProps = (state) => ({
  viewedProduct: getViewedProduct(state),
});

const mapDispatchToProps = (dispatch) => ({
  setViewedProduct: (viewedProduct) => dispatch(setViewedProduct(viewedProduct)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleProduct);
